import { cx } from 'cva'
import type { ComponentProps, FC } from 'react'

export type ControlTabProps = Omit<ComponentProps<'button'>, 'children'> & {
	title: string
	active?: boolean
}

export const ControlTab: FC<ControlTabProps> = ({ title, active, ...props }) => {
	return (
		<button
			className={cx(
				'relative',
				'cursor-pointer pb-xl text-button text-blue transition-colors duration-200',
				active && 'text-blue-shade-70',
				'hover:text-blue-shade-70',
			)}
			type="button"
			{...props}
		>
			{title}
			<span
				className={cx(
					'absolute bottom-0 left-0 block w-full bg-blue transition-all duration-200',
					active ? 'h-(length:--stroke-lg)' : 'h-0',
				)}
			/>
		</button>
	)
}
